/**
 * avatars/aliens/species/species-batch1.js
 * Dữ liệu chủng tộc văn minh (Nhóm 1).
 */

import {
  SPECIES_IGNIS,
  SPECIES_CYCLOPIA,
  SPECIES_BIONIC,
  SPECIES_CRYO,
  SPECIES_OCEAN,
  SPECIES_MYCELIUM,
  SPECIES_SYNAPSE,
  SPECIES_AURORA,
  SPECIES_OSSIFIED,
  SPECIES_QUANTUM
} from '../species-ids.js';

export const SPECIES_BATCH_1 = {
  [SPECIES_IGNIS]: {
    speciesId: 'species_ignis',
    shortName: 'Người Lửa Nham Thạch',
    cardSubtitle: 'Ignis Prime • Sừng lửa',
    name: 'Người Lửa Nham Thạch (Ignis Prime)',
    planet: 'Ignis Prime',
    lore: 'Cư dân của nền văn minh địa nhiệt phồn thịnh Ignis Prime. Họ thuần hóa magma và dòng chảy nhiệt năng để kiến tạo các thành phố bazan rực sáng, sống chan hòa với nhịp thở của lõi hành tinh.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào mừng bạn đến với Ignis Prime! Hơi ấm địa nhiệt nơi đây luôn rộng mở đón chào mọi người bạn từ tinh cầu xa xôi.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi khai thác năng lượng địa nhiệt tuần hoàn, biến dòng magma thành nguồn năng lượng sạch sưởi ấm toàn đô thị.'
      },
      {
        action: 'present',
        text: 'Cặp sừng năng lượng giúp điều hòa thân nhiệt và kết nối chúng tôi với mạng lưới địa nhiệt hành tinh.'
      }
    ],
    dna: {
      skinColor: '#991b1b',
      eyeType: 'fire',
      horns: 'devil_horns',
      wings: 'none',
      tail: 'none',
      hairColor: '#450a0a',
      eyeColor: '#f97316',
      pantsColor: '#450a0a',
      shoesColor: '#1c1917'
    },
    clothing: {
      maleOutfit: 'magma_male',
      femaleOutfit: 'magma_female',
      shirtPalette: ['#7f1d1d', '#991b1b', '#b91c1c', '#c2410c']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_CYCLOPIA]: {
    speciesId: 'species_cyclopia',
    shortName: 'Người Độc Nhãn Tinh Cầu',
    cardSubtitle: 'Cyclopia IV • 1 Mắt thần',
    name: 'Người Độc Nhãn Tinh Cầu (Cyclopia IV)',
    planet: 'Cyclopia IV',
    lore: 'Cư dân thấu thị với con mắt quang học siêu phổ trung tâm tại Cyclopia IV. Họ nổi tiếng khắp thiên hà về các công trình nghiên cứu triết học lượng tử và thiên văn học đa chiều.',
    reactions: [
      {
        action: 'wave',
        text: 'Kính chào nhà du hành vũ trụ! Đôi mắt tinh cầu của chúng tôi nhìn thấy sự chân thành trong bạn.'
      },
      {
        action: 'explain',
        text: 'Tại Cyclopia IV, thị giác đa phổ giúp chúng tôi thấu hiểu cấu trúc nguyên tử và hài hòa với hệ sinh thái tinh cầu.'
      },
      {
        action: 'present',
        text: 'Chúng tôi sử dụng thấu kính giao tiếp vi lượng để kết nối tri thức với các nền văn minh thân hữu.'
      }
    ],
    dna: {
      skinColor: '#a855f7',
      eyeType: 'cyclops',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#312e81',
      eyeColor: '#22d3ee',
      pantsColor: '#1e1b4b',
      shoesColor: '#0f172a'
    },
    clothing: {
      maleOutfit: 'cyclopia_male',
      femaleOutfit: 'cyclopia_female',
      shirtPalette: ['#334155', '#475569', '#6d28d9', '#4338ca']
    },
    demographics: {
      maleHair: 'bald',
      femaleHair: 'long_hair',
      childHair: 'spiky',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_BIONIC]: {
    speciesId: 'species_bionic',
    shortName: 'Cư Dân Bionic Cơ Giới',
    cardSubtitle: 'Neon-Synthetica • Titan visor',
    name: 'Cư Dân Bionic Cơ Giới (Neon-Synthetica)',
    planet: 'Neon-Synthetica',
    lore: 'Xã hội cộng sinh hài hòa giữa sinh học và công nghệ nano tại Neon-Synthetica. Cư dân tự hoàn thiện thể chất để thám hiểm không gian sâu và nghiên cứu bảo tồn sinh quyển bền vững.',
    reactions: [
      {
        action: 'wave',
        text: 'Giao thức chào đón khởi động thành công. Rất vinh hạnh được đón tiếp bạn tại Neon-Synthetica!'
      },
      {
        action: 'explain',
        text: 'Chúng tôi kết hợp tri giác sinh học với hợp kim titan tái chế để bảo tồn tài nguyên sinh thái của hành tinh.'
      },
      {
        action: 'present',
        text: 'Kính thực tế vi mạch hiển thị các thông số môi trường tối ưu cho sự sống của mọi sinh mệnh.'
      }
    ],
    dna: {
      skinColor: '#64748b',
      eyeType: 'cyber_visor',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#0f766e',
      eyeColor: '#06b6d4',
      pantsColor: '#0f172a',
      shoesColor: '#020617'
    },
    clothing: {
      maleOutfit: 'bionic_male',
      femaleOutfit: 'bionic_female',
      shirtPalette: ['#0f172a', '#1e293b', '#0369a1', '#0f766e']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'neat_parted',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_CRYO]: {
    speciesId: 'species_cryo',
    shortName: 'Người Băng Tinh Tuyết Tộc',
    cardSubtitle: 'Cryonia • Sừng thạch anh',
    name: 'Người Băng Tinh Tuyết Tộc (Cryonia)',
    planet: 'Cryonia',
    lore: 'Tộc người tao nhã sống tại những lâu đài tinh thể băng vĩnh cửu Cryonia. Họ làm chủ công nghệ siêu dẫn nhiệt độ siêu hàn và duy trì lối sống thanh bình, hiếu khách.',
    reactions: [
      {
        action: 'wave',
        text: 'Xin gửi lời chào thanh mát từ cao nguyên băng giá Cryonia đến người bạn không gian!'
      },
      {
        action: 'explain',
        text: 'Băng tinh thể tại Cryonia mang cấu trúc siêu dẫn hoàn mỹ, nuôi dưỡng công nghệ năng lượng tuần hoàn vĩnh cửu.'
      },
      {
        action: 'present',
        text: 'Sừng tinh thể băng tuyết là cơ quan cảm ứng bức xạ thiên hà cực kỳ nhạy bén của chúng tôi.'
      }
    ],
    dna: {
      skinColor: '#bae6fd',
      eyeType: 'star',
      horns: 'crystal_horns',
      wings: 'none',
      tail: 'none',
      hairColor: '#e0f2fe',
      eyeColor: '#38bdf8',
      pantsColor: '#0c4a6e',
      shoesColor: '#082f49'
    },
    clothing: {
      maleOutfit: 'cryo_male',
      femaleOutfit: 'cryo_female',
      shirtPalette: ['#0284c7', '#0369a1', '#0ea5e9', '#38bdf8']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_OCEAN]: {
    speciesId: 'species_ocean',
    shortName: 'Người Thủy Tộc Biển Sâu',
    cardSubtitle: 'Aquaterra • Nan vây phát quang',
    name: 'Người Thủy Tộc Biển Sâu (Aquaterra)',
    planet: 'Aquaterra',
    lore: 'Nền văn minh dưới nước tuyệt mỹ tại đại dương ngầm Aquaterra. Họ là những người bảo tồn hệ sinh thái biển, kiến tạo đô thị cộng sinh cùng rạn san hô phát quang và các dòng hải lưu liên sao.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào mừng bạn ghé thăm dòng hải lưu thanh bình của Aquaterra!'
      },
      {
        action: 'explain',
        text: 'Chúng tôi xây dựng các thành phố vòm sinh học cộng sinh với san hô phát quang và các loài sinh vật biển.'
      },
      {
        action: 'present',
        text: 'Vây lưng khí động học giúp chúng tôi chuyển động nhịp nhàng cùng các làn sóng năng lượng đại dương.'
      }
    ],
    dna: {
      skinColor: '#06b6d4',
      eyeType: 'normal',
      horns: 'none',
      wings: 'fish_fin',
      tail: 'none',
      hairColor: '#164e63',
      eyeColor: '#06b6d4',
      pantsColor: '#155e75',
      shoesColor: '#083344'
    },
    clothing: {
      maleOutfit: 'ocean_male',
      femaleOutfit: 'ocean_female',
      shirtPalette: ['#0e7490', '#155e75', '#0891b2', '#0284c7']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_MYCELIUM]: {
    speciesId: 'species_mycelium',
    shortName: 'Người Bào Tử Dạ Quang',
    cardSubtitle: 'Fungalia • Mũ nấm phát quang',
    name: 'Người Bào Tử Dạ Quang (Fungalia)',
    planet: 'Fungalia',
    lore: 'Cư dân thông thái của mạng lưới sinh học Fungalia. Nhờ kết nối tâm thức tập thể với rừng nấm dạ quang khổng lồ, họ sở hữu nền y học sinh thái chữa lành mọi tổn thương sinh học.',
    reactions: [
      {
        action: 'wave',
        text: 'Kính chào lữ khách! Rừng nấm dạ quang Fungalia đêm nay rực sáng đón chào bạn.'
      },
      {
        action: 'explain',
        text: 'Mỗi cá thể chúng tôi là một nốt nhạc trong bản giao hưởng sinh học vĩ đại trải dài toàn hành tinh.'
      },
      {
        action: 'present',
        text: 'Bào tử phát quang của chúng tôi là nguồn sáng tự nhiên nuôi dưỡng sự sống và thanh lọc bầu khí quyển.'
      }
    ],
    dna: {
      skinColor: '#a7f3d0',
      eyeType: 'normal',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#064e3b',
      eyeColor: '#34d399',
      pantsColor: '#065f46',
      shoesColor: '#022c22'
    },
    clothing: {
      maleOutfit: 'mycelium_male',
      femaleOutfit: 'mycelium_female',
      shirtPalette: ['#047857', '#065f46', '#059669', '#10b981']
    },
    demographics: {
      maleHair: 'bald',
      femaleHair: 'long_hair',
      childHair: 'bald',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_SYNAPSE]: {
    speciesId: 'species_synapse',
    shortName: 'Cư Dân Tâm Trí Đồng Thuận',
    cardSubtitle: 'Synapse-Net • Sóng não psionic',
    name: 'Cư Dân Tâm Trí Đồng Thuận (Synapse-Net)',
    planet: 'Synapse-Net',
    lore: 'Xã hội hòa bình tuyệt đối nơi mọi bất đồng được giải quyết qua mạng lưới thấu cảm và chia sẻ nhận thức lượng tử. Họ tôn trọng sự độc lập của tư duy trong sự liên kết hài hòa.',
    reactions: [
      {
        action: 'wave',
        text: 'Tâm ý giao hòa! Chúng tôi gửi lời chào bác ái trực tiếp tới tâm thức thân thiện của bạn.'
      },
      {
        action: 'explain',
        text: 'Sự đồng thuận của chúng tôi bắt nguồn từ sự lắng nghe sâu sắc và thấu cảm trọn vẹn từng suy nghĩ của muôn loài.'
      },
      {
        action: 'present',
        text: 'Hệ cảm biến sóng thần kinh giúp chúng tôi duy trì sự đồng bộ và hài hòa không bao giờ có xung đột.'
      }
    ],
    dna: {
      skinColor: '#f472b6',
      eyeType: 'star',
      horns: 'tesla_antennae',
      wings: 'none',
      tail: 'none',
      hairColor: '#701a75',
      eyeColor: '#f472b6',
      pantsColor: '#4a044e',
      shoesColor: '#2e1065'
    },
    clothing: {
      maleOutfit: 'synapse_male',
      femaleOutfit: 'synapse_female',
      shirtPalette: ['#831843', '#9d174d', '#be185d', '#a21caf']
    },
    demographics: {
      maleHair: 'bald',
      femaleHair: 'long_hair',
      childHair: 'spiky',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_AURORA]: {
    speciesId: 'species_aurora',
    shortName: 'Người Du Mục Cực Quang',
    cardSubtitle: 'Borealis-V • Dải lụa cực quang',
    name: 'Người Du Mục Cực Quang (Borealis-V)',
    planet: 'Borealis-V',
    lore: 'Những nhà thơ và nghệ sĩ du mục sống trên các tầng mây ion hóa của Borealis-V. Họ dệt ánh sáng cực quang thành các dải lụa bảo vệ môi trường và sưởi ấm tinh cầu trong đêm lạnh.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào bạn hiền! Bầu trời cực quang Borealis-V đang nở hoa ánh sáng để chúc phúc cho bạn.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi sống lướt theo các luồng gió mặt trời, biến bức xạ ion thành nghệ thuật dải lụa quang phổ.'
      },
      {
        action: 'present',
        text: 'Dải lụa cực quang này đan từ photon ánh sáng, sưởi ấm cho mọi tâm hồn trong đêm trường vũ trụ.'
      }
    ],
    dna: {
      skinColor: '#c4b5fd',
      eyeType: 'star',
      horns: 'none',
      wings: 'aurora_ribbon',
      tail: 'none',
      hairColor: '#4c1d95',
      eyeColor: '#a78bfa',
      pantsColor: '#2e1065',
      shoesColor: '#1e1b4b'
    },
    clothing: {
      maleOutfit: 'aurora_male',
      femaleOutfit: 'aurora_female',
      shirtPalette: ['#6d28d9', '#5b21b6', '#7c3aed', '#8b5cf6']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_OSSIFIED]: {
    speciesId: 'species_ossified',
    shortName: 'Người Cốt Giáp Cổ Xưa',
    cardSubtitle: 'Ossuary-Prime • Khung xương cổ',
    name: 'Người Cốt Giáp Cổ Xưa (Ossuary-Prime)',
    planet: 'Ossuary-Prime',
    lore: 'Nền văn minh triết học lâu đời của các học giả tại Ossuary-Prime. Họ gìn giữ hóa thạch cổ sinh và ký ức hàng tỷ năm của vũ trụ, xem mỗi lớp trầm tích là pho sử thi về nguồn cội sự sống.',
    reactions: [
      {
        action: 'wave',
        text: 'Kính chào vị khách quý! Hãy cùng chúng tôi bước vào bảo tàng ký ức cổ xưa của vũ trụ.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi trân quý từng mảnh hóa thạch như một pho sử thi ghi chép nguồn cội muôn loài từ thuở khai nguyên.'
      },
      {
        action: 'present',
        text: 'Bộ giáp cốt chất này là biểu tượng của sự kiên cường và lòng tôn kính sâu sắc đối với tiền nhân.'
      }
    ],
    dna: {
      skinColor: '#e7e5e4',
      eyeType: 'normal',
      hat: 'bone_mask',
      horns: 'devil_horns',
      wings: 'none',
      tail: 'none',
      hairColor: '#292524',
      eyeColor: '#fbbf24',
      pantsColor: '#1c1917',
      shoesColor: '#0c0a09'
    },
    clothing: {
      maleOutfit: 'ossified_male',
      femaleOutfit: 'ossified_female',
      shirtPalette: ['#44403c', '#57534e', '#292524', '#78716c']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_QUANTUM]: {
    speciesId: 'species_quantum',
    shortName: 'Nhà Khám Phá Lượng Tử',
    cardSubtitle: 'Quantum-X • Vòm thám hiểm',
    name: 'Nhà Khám Phá Lượng Tử (Quantum-X)',
    planet: 'Quantum-X',
    lore: 'Cộng đồng các nhà khoa học và nhà thám hiểm lượng tử liên thiên hà. Họ tiên phong xây dựng cầu nối hòa bình giữa các nền văn minh và bảo vệ sự toàn vẹn của không thời gian.',
    reactions: [
      {
        action: 'wave',
        text: 'Xin chào đồng nghiệp nghiên cứu vũ trụ! Chúc bạn một hành trình khám phá lượng tử tuyệt vời.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi phát triển công nghệ du hành không gian không để lại bất kỳ dấu vết carbon hay ô nhiễm nào.'
      },
      {
        action: 'present',
        text: 'Thiết bị cảm biến lượng tử cầm tay cho phép phân tích sự an toàn sinh thái của mọi vùng đất mới.'
      }
    ],
    dna: {
      skinColor: '#fcd5b5',
      eyeType: 'normal',
      hat: 'astronaut_helm',
      bodyAccessory: 'jetpack',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#0e7490',
      eyeColor: '#22d3ee',
      pantsColor: '#155e75',
      shoesColor: '#083344'
    },
    clothing: {
      maleOutfit: 'quantum_male',
      femaleOutfit: 'quantum_female',
      shirtPalette: ['#0284c7', '#0369a1', '#0f766e', '#1e293b']
    },
    demographics: {
      maleHair: 'neat_parted',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  }
};
